<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <section>
    <div class="content-wrapper pos-rel-md">
      <h1 class="prefs-heading">
        {{ pageData.title || 'Marketing Preferences' }}
      </h1>
      <div class="separator"></div>

      <div class="content">
        <div class="prefs-intro">
          <app-render-markdown [content]="pageData.intro"></app-render-markdown>
        </div>
        <div class="prefs-intro" *ngIf="!pageData.intro">
          <p>
            Howden for Students would like to let you know about our products,
            discounts, rewards and competitions we think you'd be interested in.
          </p>
          <p>
            Your information will not be shared with anyone outside the Howden
            for Students for marketing purposes.
          </p>
        </div>
        <form
          class="prefs-form"
          [formGroup]="prefsForm"
          (ngSubmit)="submit($event)"
        >
          <label
            for="receive_emails"
            class="toggle receive-emails-toggle-label"
          >
            <span
              class="receive-emails-toggle-label-text"
              [style.color]="accepted ? '#0857c3' : '#173f35'"
              >{{ pageData.email_toggle_label || 'Receive emails' }}</span
            >
            <span class="switch">
              <input
                formControlName="receiveEmails"
                id="receive_emails"
                type="checkbox"
                name="receive-emails-toggle"
                class="toggle"
                value="1"
              />
              <span class="slider"></span>
            </span>
          </label>
        </form>
        <p class="update-error" *ngIf="updateError">
          We're sorry, there was a problem updating your preferences. Please try
          again or <a routerLink="/contact-us/form">contact us</a> for
          assistance.
        </p>
        <div class="prefs-outro">
          <app-render-markdown [content]="pageData.outro"></app-render-markdown>
        </div>
        <div class="prefs-outro" *ngIf="!pageData.outro">
          <p>
            Note: If you switch our offer emails off, you will still receive
            service communications from My Endsleigh
          </p>
        </div>
      </div>
    </div>
  </section>
</div>
